import { useQuery } from '@tanstack/react-query'
import { splitService } from '@/services/split.service'

export function useSplits(filters: { parceiro_id?: string, status?: string, page?: number, pageSize?: number } = {}) {
    return useQuery({
        queryKey: ['splits', filters],
        queryFn: () => splitService.list(filters),
    })
}
